var map = {
	"./sa-alamo.jpg": 9335,
	"./sa-riverwalk.jpg": 7630,
	"./sa-skyline.jpg": 8922,
	"./slide-1.png": 719,
	"./slide-2.png": 7508,
	"./slide-3.png": 1405,
	"./slide-4.png": 6546,
	"./slide-5.png": 7723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6300;